export class Group {
  constructor(obj) {
    this.groupId = obj.id;
    this.name = obj.name;
    this.isEnigma = obj.isEnigma;
    this.poiIds = obj.poiIds;
    this.networkId = obj.networkId;
    this.account = obj.account;
  }
}
